import { useCssModule, computed } from "vue";
import { B as BaseLink, u as useLinkProps } from "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-CgZzOVq6.js";
import { u as useListeners } from "./assets/index-Ca8wHgNc.js";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { u as useElevationProp } from "./assets/index-hC42R8vZ.js";
import "./assets/index-vzP2cezV.js";
import "vue-demi";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
const card = "_card_1egbd_1";
const isOutlined = "_isOutlined_1egbd_11";
const style0 = {
  card,
  isOutlined
};
const VALID_TAGS = ["div", "section", "li", "button", "a"];
const { createElevationProp, getElevationBoxShadow } = useElevationProp();
const { createLinkProps, getLinkProps } = useLinkProps();
const { createDisabledProp } = useDisabledProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XCard",
  components: { BaseLink }
};
const _sfc_main = Object.assign(__default__, {
  props: {
    tag: {
      type: String,
      default: "div",
      validation: (tag) => VALID_TAGS.includes(tag)
    },
    borderRadius: {
      type: String,
      default: "var(--border-radius-medium)"
    },
    outlined: {
      type: Boolean,
      default: false
    },
    padding: {
      type: String,
      default: "var(--space-regular)"
    },
    ...createElevationProp(),
    ...createLinkProps(),
    ...createDisabledProp(),
    ...createTestIdProp()
  },
  emits: ["click"],
  setup(__props, { emit }) {
    const props = __props;
    const $style = useCssModule();
    const { boxShadow } = getElevationBoxShadow(props);
    const { formatTestId } = setupTestId(props);
    const { v2Listeners } = useListeners(["click"]);
    const isLink = computed(() => props.tag === "a");
    const computedStyles = computed(() => ({
      ...boxShadow.value,
      borderRadius: props.borderRadius,
      "--xCard-padding": props.padding
    }));
    const cardClasses = computed(() => ({
      [$style.isOutlined]: props.outlined
    }));
    const cardTag = computed(() => {
      if (isLink.value) return "BaseLink";
      return props.tag;
    });
    const cardArgs = computed(() => {
      const baseArgs = {
        disabled: props.disabled
      };
      if (isLink.value) {
        return {
          ...baseArgs,
          ...getLinkProps(props)
        };
      }
      return baseArgs;
    });
    function clickHandler(event) {
      emit("click", event);
    }
    return { __sfc: true, VALID_TAGS, createElevationProp, getElevationBoxShadow, createLinkProps, getLinkProps, createDisabledProp, createTestIdProp, setupTestId, props, emit, $style, boxShadow, formatTestId, v2Listeners, isLink, computedStyles, cardClasses, cardTag, cardArgs, clickHandler };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.cardTag, _vm._g(_vm._b({ tag: "component", class: [_setup.$style.card, _setup.cardClasses], style: _setup.computedStyles, attrs: { "data-testid": _setup.formatTestId() }, on: { "click": _setup.clickHandler } }, "component", _setup.cardArgs, false), _setup.v2Listeners), [_vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XCard = __component__.exports;
export {
  VALID_TAGS,
  XCard as default
};
